import uuid from "uuid/v4";

import { DocumentClient } from "@examspark/common-aws";
import { RolePolicy, RolePolicyCedar, Workspace } from "@examspark/types";

import { schemaParams, timestampParams } from "..";

import { putTypedItem, queryAllResourcesByWorkspaceId } from ".";

export const createRole = (params: {
  client: DocumentClient;
  workspaceId: string;
  tableName: string;
  roleName: string;
  rolePolicyName: string;
  rolePolicyDescription: string;
  rolePolicyCedar: RolePolicyCedar;
}) => {
  const TableName = params.tableName;
  const { workspaceId, client } = params;

  const roleId = uuid();
  const putRole = putTypedItem({
    client,
    putParams: {
      TableName,
      Item: {
        id: roleId,
        sk: "role",
        __typename: "Role",
        name: params.roleName,
        workspaceId: workspaceId,
        ...timestampParams(),
        ...schemaParams(),
      },
    },
  });

  const rolePolicyId = uuid();
  const putRolePolicy = putTypedItem({
    client,
    putParams: {
      TableName,
      Item: {
        id: roleId,
        sk: `role-policy#${rolePolicyId}`,
        __typename: "RolePolicy",
        name: params.rolePolicyName,
        workspaceId: workspaceId,
        ...timestampParams(),
        ...schemaParams(),
        description: params.rolePolicyDescription,
        cedar: params.rolePolicyCedar,
      } satisfies RolePolicy,
    },
  });

  return {
    role: {
      id: roleId,
      sk: "role",
    },
    rolePolicy: {
      id: roleId,
      sk: `role-policy#${rolePolicyId}`,
    },
    promises: [putRole, putRolePolicy],
  };
};

export const listWorkspaceRoles = async (params: {
  client: DocumentClient;
  workspaceId: string;
  tableName: string;
}) => {
  const TableName = params.tableName;
  const { workspaceId, client } = params;

  const result = await queryAllResourcesByWorkspaceId<Workspace>(client, {
    tableName: TableName,
    workspaceId,
    sortKeyEquals: "role",
  });

  return result;
};
